import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { jbApi } from '../api';

export default function NotificationBell({ token }) {
  const [count, setCount]   = useState(0);
  const [open, setOpen]     = useState(false);
  const [items, setItems]   = useState([]);
  const ref = useRef(null);

  // Poll unread count every 30s
  useEffect(() => {
    if (!token) return;
    let mounted = true;
    const poll = () => jbApi.unreadCount(token).then(d => mounted && setCount(d.unread_count || 0)).catch(() => {});
    poll();
    const id = setInterval(poll, 30000);
    return () => { mounted = false; clearInterval(id); };
  }, [token]);

  // Load notifications when panel opens
  useEffect(() => {
    if (!open || !token) return;
    jbApi.notifications(token).then(d => setItems(d.notifications || [])).catch(() => {});
  }, [open, token]);

  // Close on outside click
  useEffect(() => {
    const handler = e => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  function markAll() {
    jbApi.markAllRead(token).then(() => { setCount(0); setItems(prev => prev.map(n => ({ ...n, is_read: true }))); });
  }

  return (
    <div ref={ref} style={{ position:'relative' }} data-testid="notification-bell">
      <button
        onClick={() => setOpen(o => !o)}
        data-testid="bell-btn"
        style={{
          position:'relative', background:'rgba(255,255,255,.1)', border:'none',
          borderRadius:8, padding:'8px 10px', cursor:'pointer', color:'#f5f0e8',
          display:'flex', alignItems:'center', gap:4, fontSize:18,
        }}
      >
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9M13.73 21a2 2 0 01-3.46 0"/>
        </svg>
        {count > 0 && (
          <span data-testid="unread-badge" style={{
            position:'absolute', top:-4, right:-4, background:'#c0392b',
            color:'#fff', fontSize:10, fontWeight:800,
            borderRadius:999, width:16, height:16,
            display:'flex', alignItems:'center', justifyContent:'center', lineHeight:1,
          }}>{count > 9 ? '9+' : count}</span>
        )}
      </button>

      {open && (
        <div data-testid="notification-drawer" style={{
          position:'absolute', right:0, top:'calc(100% + 8px)',
          width:320, maxHeight:420, overflowY:'auto',
          background:'#fff', borderRadius:12, boxShadow:'0 12px 40px rgba(0,0,0,.18)',
          border:'1px solid #ddd8cc', zIndex:200,
        }}>
          <div style={{ padding:'12px 16px', borderBottom:'1px solid #ddd8cc', display:'flex', alignItems:'center', justifyContent:'space-between' }}>
            <span style={{ fontWeight:700, fontSize:14, color:'#0D2137' }}>Notifications</span>
            {count > 0 && <button onClick={markAll} style={{ fontSize:11, color:'#1B6B72', background:'none', border:'none', cursor:'pointer', fontWeight:600, padding:0 }}>Mark all read</button>}
          </div>
          {items.length === 0
            ? <div style={{ padding:24, textAlign:'center', color:'#94a3b8', fontSize:13 }}>No notifications yet</div>
            : items.map(n => (
              <div key={n.id} style={{
                padding:'10px 16px', borderBottom:'1px solid #f5f0e8',
                background: n.is_read ? '#fff' : 'rgba(27,107,114,.04)',
                cursor:'default',
              }}>
                <div style={{ fontSize:13, fontWeight: n.is_read ? 400 : 600, color:'#0D2137', marginBottom:2 }}>{n.title}</div>
                <div style={{ fontSize:12, color:'#5a6373', lineHeight:1.4 }}>{n.message}</div>
              </div>
            ))
          }
        </div>
      )}
    </div>
  );
}
